export const CheckBoxData = [
  {
    value: 'Retail Space',
    label: 'Retail Space',
  },
  {
    value: 'Office Space',
    label: 'Office Space',
  },
  {
    value: 'Industrial Space',
    label: 'Industrial Space',
  },
  {
    value: 'Warehouse Space',
    label: 'Warehouse Space',
  },
  {
    value: 'Multifamily',
    label: 'Multifamily',
  },
  {
    value: 'Flex Space',
    label: 'Flex Space',
  },
  {
    value: 'Special Purpose',
    label: 'Special Purpose',
  },
  {
    value: 'Single Tenant Retail',
    label: 'Single Tenant Retail',
  },
  {
    value: 'Single Tenant office',
    label: 'Single Tenant office',
  },
  {
    value: 'Restaurant Space',
    label: 'Restaurant Space',
  },
  {
    value: 'Residential',
    label: 'Residential',
  },
  {
    value: 'Other Space',
    label: 'Other Space',
  },
];

export const countryData = [
  { label: 'North America', value: 'North America' },
  { label: 'South America', value: 'South America' },
  { label: 'Asia', value: 'Asia' },
  { label: 'Europe', value: 'Europe' },
  { label: 'Africa', value: 'Africa' },
  { label: 'Australia/New Zealand', value: 'Australia/New Zealand' },
];
